import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { filter, startWith, Subject } from 'rxjs';
import { TranslationService } from '@waseel-asp/tpa-waseel-lib-staging';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  private titleService = inject(Title);
  private router = inject(Router);
  private translation = inject(TranslationService);

  title = new Subject<string>();

  setTitle() {
    this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      startWith(new NavigationEnd(0, this.router.url, this.router.url))).subscribe((event: NavigationEnd) => {
        if (event instanceof NavigationEnd) {
          setTimeout(() => {
            const title = this.titleService.getTitle();
            this.titleService.setTitle(this.translation.instant(title));
            this.title.next((title));
          }, 50);
        }
      });
  }
}